<template>
  <div>
    <template v-if="contentItem.contentType === 'figure'">
      <content-figure :figure-attr="contentItem.content"></content-figure>
    </template>
    <template v-else-if="contentItem.contentType === 'table'">
      <content-table :table-content="contentItem"></content-table>
    </template>
    <template v-else>
      <content-element :tag-name="contentItem.contentType || 'p'" v-html="contentItem.content || contentItem.content_part"></content-element>
    </template>
  </div>
</template>
<script>
  import ContentElement from '@/components/shared/article-items/ContentElementComponent'
  import ContentFigure from '@/components/shared/article-items/ContentFigureComponent'
  import ContentTable from '@/components/shared/article-items/ContentTableComponent'
  export default {
    name: 'content-item',
    components: {
      ContentElement,
      ContentFigure,
      ContentTable
    },
    props: {
      contentItem: {
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ContentItemComponent.vue?4decf416